import { all, takeEvery, call, put } from 'redux-saga/effects';
import { request, isApiError } from '../../xhr';
import { watchTopic, watchTopicSuccess, watchTopicFailure, unwatchTopic, unwatchTopicSuccess, unwatchTopicFailure, suppressTopic, suppressTopicSuccess, suppressTopicFailure } from './actions';
export function* handleWatchTopic({ payload: { params , onSuccess  }  }) {
    const { necoid , suggested_neco_id_lists =[] , source  } = params;
    const result = yield call(request, {
        method: 'post',
        url: '/topic/watch',
        data: {
            necoid,
            suggested_neco_id_lists: JSON.stringify(suggested_neco_id_lists),
            source
        }
    });
    if (!result || isApiError(result)) {
        yield put(watchTopicFailure(params));
    } else {
        yield put(watchTopicSuccess(params, result));
        onSuccess && onSuccess(result);
    }
}
export function* handleUnwatchTopic({ payload: { params , onSuccess  }  }) {
    const result = yield call(request, {
        method: 'post',
        url: '/topic/unwatch',
        data: params
    });
    if (!result || isApiError(result)) {
        yield put(unwatchTopicFailure(params));
    } else {
        yield put(unwatchTopicSuccess(params, result));
        onSuccess && onSuccess(result);
    }
}
export function* handleSuppressTopic({ payload: { params , onSuccess  }  }) {
    const result = yield call(request, {
        method: 'post',
        url: '/topic/suppress',
        data: params
    });
    if (!result || isApiError(result)) {
        yield put(suppressTopicFailure(params));
    } else {
        yield put(suppressTopicSuccess(params, result));
        onSuccess && onSuccess(result);
    }
}
export default function* saga() {
    yield all([
        takeEvery(watchTopic, handleWatchTopic),
        takeEvery(unwatchTopic, handleUnwatchTopic),
        takeEvery(suppressTopic, handleSuppressTopic)
    ]);
}
